export interface Validator {
  name: string;
  validator: any;
  message: string;
}
export interface FieldConfig {
  label?: string;
  name?: string;
  placeholder?: string;
  inputType?: string;
  options?: any;
  required?: string;
  collections?: any;
  type?: string;
  value?: any;
  regex?: any;
  dependentField?: any;
  dependentOption?: any;
  validations?: Validator[];
  containerClass?: string;
  onChangeRequired?: true;
  disabled?: boolean;
}
export const mandatoryFields: FieldConfig[] = [
  {
    type: "text",
    label: "First Name",
    inputType: "text",
    name: "firstName",
    placeholder: "First Name",
    required: "true",
    /*regex: "[A-z]*",*/
    regex: "[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'`'.@-]*",
    containerClass: 'col-md-6 d-inline-flex mb-4'
  },
  {
    type: "text",
    label: "Last Name",
    inputType: "text",
    name: "lastName",
    placeholder: "Last Name",
    required: "true",
    /*regex: "[A-z]*",*/
    regex: "[a-zA-z][a-zA-Z ]*",
    containerClass: 'col-md-6 d-inline-flex mb-4'
  },
  {
    type: "text",
    label: "Email Address",
    inputType: "text",
    name: "emailAddress",
    placeholder: "Email Address",
    required: "true",
    /* regex: "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",*/
    regex: "^[A-z0-9._%+-]+@[A-z0-9.-]+\\.[A-z]{2,4}$",
    containerClass: 'col-md-6 d-inline-flex mb-4'
  },
  {
    type: "text",
    label: "Phone Number",
    inputType: "text",
    name: "phoneNumber",
    placeholder: "Phone Number",
    required: "true",
    /* regex: "^\\d{10}$",*/
    regex: "^(\\+\\d{1,3}( )?)?((\\(\\d{1,3}\\))|\\d{1,3})[- .]?\\d{3,4}[- .]?\\d{4}$",
    containerClass: 'col-md-6 d-inline-flex mb-4'
  }
]
